var DependencyGraphTypes;
((DependencyGraphTypes2) => {
  ((Direction2) => {
    Direction2["TOP_BOTTOM"] = "TB";
    Direction2["BOTTOM_TOP"] = "BT";
    Direction2["LEFT_RIGHT"] = "LR";
    Direction2["RIGHT_LEFT"] = "RL";
  })(DependencyGraphTypes2.Direction || (DependencyGraphTypes2.Direction = {}));
  ((Alignment2) => {
    Alignment2["UP_LEFT"] = "UL";
    Alignment2["UP_RIGHT"] = "UR";
    Alignment2["DOWN_LEFT"] = "DL";
    Alignment2["DOWN_RIGHT"] = "DR";
  })(DependencyGraphTypes2.Alignment || (DependencyGraphTypes2.Alignment = {}));
  ((Ranker2) => {
    Ranker2["NETWORK_SIMPLEX"] = "network-simplex";
    Ranker2["TIGHT_TREE"] = "tight-tree";
    Ranker2["LONGEST_PATH"] = "longest-path";
  })(DependencyGraphTypes2.Ranker || (DependencyGraphTypes2.Ranker = {}));
  ((LabelPosition2) => {
    LabelPosition2["LEFT"] = "l";
    LabelPosition2["RIGHT"] = "r";
    LabelPosition2["CENTER"] = "c";
  })(DependencyGraphTypes2.LabelPosition || (DependencyGraphTypes2.LabelPosition = {}));
})(DependencyGraphTypes || (DependencyGraphTypes = {}));

export { DependencyGraphTypes };
//# sourceMappingURL=types.esm.js.map
